import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, services, sizes } from '@/utils'

import button from '@/components/button'
import { baseClass } from '@/components/rules/utils'
import ruleActions from '@/components/services/tariffs/rules/rule/actions'
import packets from '@/components/services/tariffs/rules/rule/packets'
import priceRanges from '@/components/services/tariffs/rules/rule/priceRanges'
import tag from '@/components/tag'

function renderTitle(h) {
  let titleKey
  if (this.isMultiple) {
    titleKey = 'otherCases'
  } else {
    titleKey = 'always'
  }

  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${services.tariffs}.${titleKey}`),
        size: sizes.huge,
        color: Colors.grey
      }
    }
  )
}

function renderActions(h) {
  return h(
    ruleActions,
    {
      props: {
        value: this.proxy,
        source: this.source
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

function renderPricesRanges(h) {
  return h(
    priceRanges,
    {
      props: {
        value: this.proxy.priceRanges
      },
      on: {
        input: event => {
          this.proxy.priceRanges = event
        }
      }
    }
  )
}
function renderPackets(h) {
  return h(
    packets,
    {
      props: {
        value: this.proxy.packets
      },
      on: {
        input: event => {
          this.proxy.packets = event
        }
      }
    }
  )
}
function renderRanges(h) {
  return h(
    'div',
    {
      class: `${services.tariffs}-rule__ranges`
    },
    [
      renderPricesRanges.call(this, h),
      renderPackets.call(this, h)
    ]
  )
}

function renderRemoveButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate(`${baseClass}.buttons.remove.rule`),
        size: sizes.small,
        mode: buttonModes.flat,
        color: Colors.error
      },
      on: {
        click: () => {
          this.$emit('remove')
        }
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: `${services.tariffs}-rule__footer`
    },
    [ renderRemoveButton.call(this, h) ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${services.tariffs}-rule`
    },
    [
      renderTitle.call(this, h),
      renderActions.call(this, h),
      renderRanges.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
